import { render } from "./RatingBox.vue?vue&type=template&id=1d99369a"
import script from "./RatingBox.vue?vue&type=script&lang=js"
export * from "./RatingBox.vue?vue&type=script&lang=js"

import exportComponent from "/Users/onisiforosgeorgiou/WebstormProjects/AgencyNow/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__